import styled from '../../utils/styled';

const getColor = (primaryColor, item, active, alternate) => {
  if (alternate) return '#002266';

  if (primaryColor && item.textColor === 'primary') {
    return primaryColor;
  }
  if (active && item.activeTextColor) {
    return item.activeTextColor;
  }
  if (item.textColor) {
    return item.textColor;
  }

  return '#fff';
};

const getHoverColor = (primaryColor, item, alternate) => {
  if (alternate) return '#4ecef7';

  if (primaryColor && item.textColor === 'primary') {
    return primaryColor;
  }
  if (item.hoverTextColor) {
    return item.hoverTextColor;
  }

  return '#fff';
};

const getHoverBackgroundColor = (item, alternate) => {
  if (alternate) return 'transparent';

  return item.hoverBackgroundColor ? item.hoverBackgroundColor : '#383838';
};

const getBackgroundColor = (active, item, alternate) => {
  if (alternate) return 'transparent';

  if (active && item.activeBackgroundColor) {
    return item.activeBackgroundColor;
  }
  if (item.backgroundColor) {
    return item.backgroundColor;
  }

  return '#101010';
};

export const Link = styled.a(
  {
    display: 'flex',
    flex: '1',
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '12px',
    maxWidth: '200px',
    textTransform: 'uppercase',
    fontFamily: 'Spyscapetwo webfont',
  },
  ({
    primaryColor, active, item, alternate,
  }) => ({
    backgroundColor: getBackgroundColor(active, item, alternate),
    color: getColor(primaryColor, item, active, alternate),
    borderBottom: active ? '1px solid #fff' : 'none',
    borderColor: alternate ? '#f6f6f6' : 'black',
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(item, alternate),
      color: getHoverColor(primaryColor, item, alternate),
    },
  }),
);
